<!-- <blockable-div [blocked]="loading()" [blockUi]="blockUi" [minHeight]="0"> -->
@if (selectedNodes()?.length > 0 || loading()) {
    <div
        [class]="
            'flex flex-col border border-gray-500/30 rounded-md p-1 mt-1' +
            ((formControl?.disabled || disabled()) && !loading()
                ? ' bg-[var(--p-form-field-disabled-background)] text-muted-color'
                : '')
        "
        cdkDropList
        (cdkDropListDropped)="onDrop($event)"
    >
        @if (loading()) {
            <!-- for some reason this does not work in a template?-->
            <div class="flex items-center justify-between flex-row gap-2 mx-1 h-8!">
                <p-skeleton height="22px" [width]="Math.random() * 170 + 100 + 'px'" />
                <p-skeleton height="27px" width="100px" />
            </div>
            @if (this.value()?.length > 1) {
                @for (node of this.value(); track $index) {
                    @if ($index > 0) {
                        <hr class="opacity-50 dark:opacity-20" />
                        <!-- copy from above -->
                        <div class="flex items-center justify-between flex-row gap-2 mx-1 h-8!">
                            <p-skeleton height="22px" [width]="Math.random() * 170 + 100 + 'px'" />
                            <p-skeleton height="27px" width="100px" />
                        </div>
                    }
                }
            }
        }
        @for (node of selectedNodes(); track $index) {
            @if ($index > 0) {
                <hr class="opacity-50 dark:opacity-20" />
            }
            <div cdkDrag [cdkDragDisabled]="loading() || formControl?.disabled || disabled()">
                <div
                    class="border-dashed border-2 h-8 border-secondary rounded-md p-2"
                    *cdkDragPlaceholder
                ></div>

                <div
                    [class]="
                        'flex items-center justify-between flex-row gap-2 mx-1' +
                        (!loading() && !formControl?.disabled && !disabled()
                            ? ' cursor-grab'
                            : ' cursor-no-drop select-none')
                    "
                >
                    <span>
                        <span class="text-muted-color opacity-50">{{ getPath(node.key) }}</span>
                        @if (node.key === FUZZY_SIMILARITY_SORT_KEY) {
                            <i>{{
                                node.label ??
                                    ('entity-search-settings.fuzzy-similarity' | translate)
                            }}</i>
                        } @else if (node.key === FULL_TEXT_SEARCH_SCORE_KEY) {
                            <i>{{
                                node.label ??
                                    ('entity-search-settings.full-text-search-score' | translate)
                            }}</i>
                        } @else {
                            {{ node.label }}
                        }
                    </span>
                    <div class="flex items-center gap-3">
                        <p-tag
                            [class]="
                                !formControl?.disabled && !disabled() && !loading()
                                    ? 'cursor-pointer'
                                    : 'select-none opacity-50'
                            "
                            [icon]="
                                node.data.order === 'ASC'
                                    ? 'fa-solid fa-arrow-up-z-a'
                                    : 'fa-solid fa-arrow-down-z-a'
                            "
                            [value]="node.data.order"
                            [severity]="node.data.order === 'ASC' ? 'success' : 'info'"
                            [pTooltip]="'enums.SortOrder.' + node.data.order | translate"
                            (click)="
                                !formControl?.disabled &&
                                    !disabled() &&
                                    !loading() &&
                                    toggleOrder(node.key)
                            "
                        />
                        @if (showExtendedOptions()) {
                            <p-tag
                                [class]="
                                    !formControl?.disabled && !disabled()
                                        ? 'cursor-pointer'
                                        : 'select-none opacity-50'
                                "
                                [icon]="
                                    node.data.nulls === 'LAST'
                                        ? 'fa-solid fa-arrow-down'
                                        : 'fa-solid fa-arrow-up'
                                "
                                [severity]="node.data.nulls === 'LAST' ? 'success' : 'info'"
                                [pTooltip]="'enums.NullSortOrder.' + node.data.nulls | translate"
                                (click)="
                                    !formControl?.disabled &&
                                        !disabled() &&
                                        !loading() &&
                                        toggleNulls(node.key)
                                "
                                [value]="node.data.nulls"
                            />
                        }
                        <p-button
                            icon="fa-solid fa-x"
                            (onClick)="remove(node.key)"
                            rounded
                            text
                            size="small"
                            severity="danger"
                            [disabled]="formControl?.disabled || disabled() || loading()"
                        />
                    </div>
                </div>
            </div>
        }
    </div>
}
<div class="mt-1">
    <p-treeselect
        [disabled]="formControl?.disabled || disabled() || loading()"
        [loading]="loading()"
        class="w-full mt-2"
        [(ngModel)]="selectedNodes"
        [ngModelOptions]="{ standalone: true }"
        [options]="nodes()"
        selectionMode="checkbox"
        (onNodeExpand)="onNodeExpand($event)"
        (onNodeUnselect)="updateValue()"
        (onNodeSelect)="updateValue()"
        [placeholder]="'entity-search-settings.add-sort-field' | translate"
        fluid
        appendTo="body"
    >
        <ng-template pTemplate="itemtogglericon" let-expanded>
            @if (expanded) {
                <i
                    class="fa fa-chevron-down p-tree-node-toggle-icon text-sm"
                    aria-hidden="true"
                ></i>
            } @else {
                <i
                    class="fa fa-chevron-right p-tree-node-toggle-icon text-sm"
                    aria-hidden="true"
                ></i>
            }
        </ng-template>
        <ng-template pTemplate="default" let-node>
            <span class="flex min-w-0 flex-row items-center gap-1">
                @if (lazyExpandLoadingKey() === node.key) {
                    <span
                        class="inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center"
                        role="img"
                        [attr.aria-label]="'column-chooser.lazy-expand-loading' | translate"
                    >
                        <i
                            class="fa fa-circle-notch fa-spin text-sm text-primary"
                            aria-hidden="true"
                        ></i>
                    </span>
                }
                <span class="min-w-0">{{ node.label }}</span>
            </span>
        </ng-template>
        <ng-template #value>
            <span>
                @if (selectedNodes()?.length > 0) {
                    {{
                        'common.fields-selected-count'
                            | translate: { count: selectedNodes()?.length ?? 0 }
                    }}
                } @else {
                    {{ 'entity-search-settings.add-sort-field' | translate }}
                }
            </span>
        </ng-template>
    </p-treeselect>
    <div class="w-full flex items-center justify-end gap-2 my-1">
        <phx-checkbox
            [disabled]="loading()"
            [(ngModel)]="showExtendedOptions"
            [ngModelOptions]="{ standalone: true }"
            [label]="'common.extended-settings' | translate"
            size="small"
            class="flex"
        />
        <phx-checkbox
            [disabled]="loading()"
            [ngModel]="isSortChooserFullLoad()"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="setSortChooserFullLoad($event)"
            [label]="
                (isSortChooserFullLoad()
                    ? 'column-chooser.minimal-loading'
                    : 'column-chooser.load-all'
                ) | translate
            "
            [tooltip]="'entity-search-settings.sort-field-tree-load-hint' | translate"
            size="small"
            class="flex"
        />
    </div>
</div>
<!-- </blockable-div>

<ng-template #blockUi>
    <p-progress-spinner [style]="{ height: '30px' }" class="mt-1" />
</ng-template> -->
